/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitionType } from './CompetitionType';
import {
    CompetitionTypeFromJSON,
    CompetitionTypeFromJSONTyped,
    CompetitionTypeToJSON,
    CompetitionTypeToJSONTyped,
} from './CompetitionType';

/**
 * A single item within a competition (tournament, league, etc.)
 * @export
 * @interface CompetitionItem
 */
export interface CompetitionItem {
    /**
     * 
     * @type {CompetitionType}
     * @memberof CompetitionItem
     */
    type: CompetitionType;
    /**
     * ObjectId reference to the actual item (tournament, league, etc.)
     * @type {string}
     * @memberof CompetitionItem
     */
    refId: string;
    /**
     * Optional division label (Professional, Masters, etc.)
     * @type {string}
     * @memberof CompetitionItem
     */
    division?: string;
    /**
     * Sequence order for multi-stage competitions
     * @type {number}
     * @memberof CompetitionItem
     */
    order?: number;
}



/**
 * Check if a given object implements the CompetitionItem interface.
 */
export function instanceOfCompetitionItem(value: object): value is CompetitionItem {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('refId' in value) || value['refId'] === undefined) return false;
    return true;
}

export function CompetitionItemFromJSON(json: any): CompetitionItem {
    return CompetitionItemFromJSONTyped(json, false);
}

export function CompetitionItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionItem {
    if (json == null) {
        return json;
    }
    return {
        
        'type': CompetitionTypeFromJSON(json['type']),
        'refId': json['refId'],
        'division': json['division'] == null ? undefined : json['division'],
        'order': json['order'] == null ? undefined : json['order'],
    };
}

export function CompetitionItemToJSON(json: any): CompetitionItem {
    return CompetitionItemToJSONTyped(json, false);
}

export function CompetitionItemToJSONTyped(value?: CompetitionItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': CompetitionTypeToJSON(value['type']),
        'refId': value['refId'],
        'division': value['division'],
        'order': value['order'],
    };
}

